import React from 'react'
import HeaderTwo from "../components/header/HeaderTwo";
import BannerTwo from "../components/banner/BannerTwo";
import AboutOne from "../components/about/AboutOne";
import ServiceThree from "../components/service/ServiceThree";
import ServiceOne from "../components/service/ServiceOne";
import BusinessCaseThree from "../components/businesscase/BusinessCaseThree";
import CallToActionSeven from "../components/calltoaction/CallToActionSeven";
import TeamSix from "../components/team/TeamSix";
import BrandOne from "../components/brand/BrandOne";
import TestimonialThree from "../components/testimonials/TestimonialThree";
import WorkingProcessTwo from "../components/workingprocess/WorkingProcessTwo";



import FooterTwo from "../components/footer/FooterTwo";

function Home() {
    return (
        <div className='home-blue'>

            <HeaderTwo />
            <BannerTwo />
            <AboutOne />
            <ServiceThree />
            <ServiceOne />
             <BusinessCaseThree />
            <CallToActionSeven />
            <TestimonialThree />
            <WorkingProcessTwo />
            <FooterTwo />

        </div>
    )
}

export default Home